import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row service__wrapper q-col-gutter-x-lg q-col-gutter-y-lg"
}
const _hoisted_2 = { class: "row justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_service_item = _resolveComponent("service-item")!
  const _component_service_skeleton_item = _resolveComponent("service-skeleton-item")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!
  const _component_q_carousel = _resolveComponent("q-carousel")!
  const _component_s_icon = _resolveComponent("s-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (service, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: service.id,
              class: _normalizeClass(["col-xs-12 col-sm-6 col-md-4 row service__item-wrapper", { 'col-md-6': _ctx.isMainGrid(index) }])
            }, [
              _createVNode(_component_service_item, {
                "is-loading": _ctx.isLoading,
                class: "col-xs-12",
                service: service,
                "icon-number": index
              }, null, 8, ["is-loading", "service", "icon-number"]),
              (_ctx.isLoading)
                ? (_openBlock(), _createBlock(_component_service_skeleton_item, {
                    key: 0,
                    class: "col-xs-12"
                  }))
                : _createCommentVNode("", true)
            ], 2))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(_component_q_carousel, {
          key: 1,
          modelValue: _ctx.slide,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.slide) = $event)),
          "transition-prev": "scale",
          "transition-next": "scale",
          swipeable: "",
          animated: "",
          "control-color": "primary",
          navigation: "",
          infinite: "",
          padding: "",
          class: "service__wrapper"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceList, (service, index) => {
              return (_openBlock(), _createBlock(_component_q_carousel_slide, {
                key: index,
                name: index,
                class: "service__item-wrapper"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_service_item, {
                    "is-loading": _ctx.isLoading,
                    class: "col-xs-12 full-height",
                    service: service,
                    "icon-number": index
                  }, null, 8, ["is-loading", "service", "icon-number"]),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_service_skeleton_item, {
                        key: 0,
                        class: "col-xs-12"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        class: "s-link col-auto",
        to: { name: _ctx.serviceRouteName }
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "s-text-link" }, "Посмотреть все меры поддержки", -1)),
          _createVNode(_component_s_icon, {
            name: "app:arrow-normal-right",
            class: "s-pl-sm"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 512)), [
    [_vShow, _ctx.serviceList.length !== 0]
  ])
}